import { ComponentProps, useCallback } from "react";
import { useDispatch } from "react-redux";
import * as actionTypes from "../actions/actionTypes";
import { modalTypes } from "../constants/modalTypes";

export default () => {
  const dispatch = useDispatch(),
    showModal = useCallback(
      <T extends ModalTypes>(
        modal: T,
        props?: ComponentProps<(typeof modalTypes)[T]>,
        closeAll = false
      ) => {
        dispatch({
          type: actionTypes.SHOW_MODAL,
          component: modal,
          props: props,
          closeAll,
        });
      },
      [dispatch]
    ),
    dismissModal = useCallback(
      (ofType: boolean | ModalTypes | unknown = false) => {
        dispatch({
          type: actionTypes.DISMISS_MODAL,
          ofType,
        });
      },
      [dispatch]
    );

  return { showModal, dismissModal };
};

export enum ModalTypes {
  ADD_JOIN_DOMAIN = "ADD_JOIN_DOMAIN",
  ADD_ASSETS_TO_KIT = "ADD_ASSETS_TO_KIT",
  CANCEL_SUBSCRIPTION = "CANCEL_SUBSCRIPTION",
  CHANGE_CARD = "CHANGE_CARD",
  CHANGE_SUBSCRIPTION = "CHANGE_SUBSCRIPTION",
  CHANGE_SUBSCRIPTION_FLOW = "CHANGE_SUBSCRIPTION_FLOW",
  CONFIRMATION = "CONFIRMATION",
  CREATE_API_TOKEN = "CREATE_API_TOKEN",
  CREATE_EDIT_ASSET_VIEW = "CREATE_EDIT_ASSET_VIEW",
  CREATE_EDIT_COLOR = "CREATE_EDIT_COLOR",
  CREATE_EDIT_CUSTOM_FIELD = "CREATE_EDIT_CUSTOM_FIELD",
  CREATE_FONT = "CREATE_FONT",
  CREATE_EDIT_KIT_COLLECTION = "CREATE_EDIT_KIT_COLLECTION",
  CREATE_KIT = "CREATE_KIT",
  CREATE_KIT_VERSION = "CREATE_KIT_VERSION",
  CREATE_SECTION = "CREATE_SECTION",
  CREATE_TEMPLATE_KIT = "CREATE_TEMPLATE_KIT",
  DELETE_KIT = "DELETE_KIT",
  DELETE_SPACE = "DELETE_SPACE",
  DELETE_SPACE_USER = "DELETE_SPACE_USER",
  EDIT_INVOICE = "EDIT_INVOICE",
  EDIT_NEW_USER_ACCESS = "EDIT_NEW_USER_ACCESS",
  EDIT_ASSET_THUMBNAIL = "EDIT_ASSET_THUMBNAIL",
  EDIT_KIT = "EDIT_KIT",
  EDIT_KIT_VERSION = "EDIT_KIT_VERSION",
  EDIT_TAG = "EDIT_TAG",
  ENTERPRISE_REQUEST = "ENTERPRISE_REQUEST",
  FIGMA_FRAME_PICKER_MODAL = "FIGMA_FRAME_PICKER_MODAL",
  FIGMA_LINK_MODAL = "FIGMA_LINK_MODAL",
  FIGMA_SETUP = "FIGMA_SETUP",
  INVITE_SPACE_MEMBERS = "INVITE_SPACE_MEMBERS",
  LEAVE_SPACE = "LEAVE_SPACE",
  LIBRARY_PICKER = "LIBRARY_PICKER",
  MANAGE_COLLECTION_KITS = "MANAGE_COLLECTION_KITS",
  MANAGE_KIT_COLLECTIONS = "MANAGE_KIT_COLLECTIONS",
  SHARE_KIT = "SHARE_KIT",
  MANAGE_FILECUTS = "MANAGE_FILECUTS",
  MANAGE_PORTAL_KITS = "MANAGE_PORTAL_KITS",
  MOVE_COPY_TO_KIT = "MOVE_COPY_TO_KIT",
  MOVE_COPY_TO_SECTION = "MOVE_COPY_TO_SECTION",
  MENU_MODAL = "MENU_MODAL",
  PICK_FILE = "PICK_FILE",
  PUBLISHED_KIT_META = "PUBLISHED_KIT_META",
  SEARCH_MODAL = "SEARCH_MODAL",
  SELECT_PLAN = "SELECT_PLAN",
  SPACE_MEMBER_PERMISSIONS = "SPACE_MEMBER_PERMISSIONS",
  TRANSFER_SPACE = "TRANSFER_SPACE",
  UPLOAD_DETAILS = "UPLOAD_DETAILS",
  TFA_PASSWORD_VERIFY = "TFA_PASSWORD_VERIFY",
  TFA_SETUP = "TFA_SETUP",
  TFA_DISABLE = "TFA_DISABLE",
  TFA_CODES = "TFA_CODES",
  TFA_SUCCESS = "TFA_SUCCESS",
  KIT_NAVIGATION = "KIT_NAVIGATION",
  INSIGHTS_KIT = "INSIGHTS_KIT",
  INSIGHTS_ASSET = "INSIGHTS_ASSET",
  INSIGHTS_USER = "INSIGHTS_USER",
  INSIGHTS_DOWNLOAD = "INSIGHTS_DOWNLOAD",
}
